export default __webpack_public_path__ + "static/media/mode-33.1441cd53.svg";